import { Map } from 'immutable';

// constants
import {
  MEMBERSHIP_CONCERN_CREATE,
  MEMBERSHIP_CONCERN_UPDATE,
  MEMBERSHIP_CONCERN_DELETE,
} from '../constants/membershipConcernTypes';
import { PNM_FETCH } from '../constants/pnmTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { addToFront, remove } from '../lib/normalizedReducerHelpers';

export default (state = Map(), action) => {
  switch (action.type) {
    case MEMBERSHIP_CONCERN_CREATE: return httpReducer(state, action, { cb: addToFront() });
    case MEMBERSHIP_CONCERN_UPDATE: return httpReducer(state, action, { entity: 'membershipConcern', updateResult: false });
    case MEMBERSHIP_CONCERN_DELETE: return httpReducer(state, action, { cb: remove() });
    case PNM_FETCH: return httpReducer(state, action, { entity: 'membershipConcern', updateResult: false });
    default: return state;
  }
};
